import fvSubassembly from "../fvSubassembly"
export default class fvLineObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.initPoints = JSON.parse(JSON.stringify(this.points));
        this.initArrowWidth = 5 + (this.borderWidth) * 2;
        this.height = this.height ? this.height : this.borderWidth;
        this.width = this.width ? this.width : this.borderWidth;
        this.create();
        if (this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        //创建图元
        //添加折线
        this.lineGDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.lineDom = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        this.startArrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.endArrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.lineGDom.appendChild(this.lineDom);
        this.lineGDom.appendChild(this.startArrow);
        this.lineGDom.appendChild(this.endArrow);
        system.appendChild(this.lineGDom);
        this.createSucss(this.lineGDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.linePathDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.linePathDom);
            }
        }
        // 创建样式
        this.parent = parent;
        this.createStyle();
    }
    createStyle() {
        this.setPosition();
        // 添加虚线属性
        super.chooseRenderType(this.lineType, this.lineDom);
        this.lineDom.setAttribute('stroke-width', this.borderWidth);
        this.lineGDom.style.fill = 'rgba(0, 0, 0, 0)';
        this.setFillColor();
        // this.startArrow.setAttribute('stroke-width', 1);
        // this.endArrow.setAttribute('stroke-width', 1);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.linePathDom.innerHTML = "";
                this.drawStereo(this.linePathDom, this.lineDom);
            }
        }
    }
    // 设置位置
    setPosition() {
        //初始化线条定位
        //根据x y 因边框、缩放改变导致绘制线重新计算
        for(var i = 0; i<this.points.length; i++){
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX ;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY ;
            this.points[i][0] = parseFloat(points0 * this.magnification.x)-this.borderWidth/2+ this.cx - this.parent.parentX;
            this.points[i][1] = parseFloat(points1 * this.magnification.y)-this.borderWidth/2+this.cy - this.parent.parentY;
        }
        //构造线的真实开始点
        this.start = {
            x: (parseFloat(this.points[0][0]) + parseFloat(0)),
            y: (parseFloat(this.points[0][1]) + parseFloat(0))
        }
        //构造线的真实结束点
        this.end = {
            x: (parseFloat(this.points[1][0]) + parseFloat(0)),
            y: (parseFloat(this.points[1][1]) + parseFloat(0))
        }
        let start_x = this.start.x;
        let start_y = this.start.y;
        let end_x = this.end.x;
        let end_y = this.end.y;
        this.lineDom.setAttribute('x1', start_x);
        this.lineDom.setAttribute('y1', start_y);
        this.lineDom.setAttribute('x2', end_x);
        this.lineDom.setAttribute('y2', end_y);
        // 添加开始箭头
        switch (this.arrow) {
            case "single":
                let singlePath = this.calculateArrowCoordinates_right(start_x, start_y, end_x, end_y, 6 * Math.sqrt(this.borderWidth));
                this.startArrow.setAttribute("d", singlePath);
                this.startArrow.setAttribute('stroke-width', this.borderWidth > 1 ? this.borderWidth - this.borderWidth / 4 : this.borderWidth);
                break;
            case "double":
                let doubleStartPath = this.calculateArrowCoordinates_right(start_x, start_y, end_x, end_y, 6 * Math.sqrt(this.borderWidth));
                let doubleEndPath = this.calculateArrowCoordinates_left(start_x, start_y, end_x, end_y, 6 * Math.sqrt(this.borderWidth));
                this.startArrow.setAttribute("d", doubleStartPath);
                this.endArrow.setAttribute("d", doubleEndPath);
                this.startArrow.setAttribute('stroke-width', this.borderWidth > 1 ? this.borderWidth - this.borderWidth / 4 : this.borderWidth);
                this.endArrow.setAttribute('stroke-width', this.borderWidth > 1 ? this.borderWidth - this.borderWidth / 4 : this.borderWidth);
                break;
            case "singleSolid":
                let solidPath = this.calculateArrowCoordinates_right(start_x, start_y, end_x, end_y, 4 * Math.sqrt(this.borderWidth)) + 'Z';
                this.startArrow.setAttribute("d", solidPath);
                this.startArrow.setAttribute("fill", this.borderColor);
                this.startArrow.setAttribute('stroke-width', this.borderWidth);
                break;
            case "doubleSolid":
                let doubleSolidStartPath = this.calculateArrowCoordinates_right(start_x, start_y, end_x, end_y, 4 * Math.sqrt(this.borderWidth)) + 'Z';
                let doubleSolidEndPath = this.calculateArrowCoordinates_left(start_x, start_y, end_x, end_y, 4 * Math.sqrt(this.borderWidth)) + 'Z';
                this.startArrow.setAttribute("d", doubleSolidStartPath);
                this.endArrow.setAttribute("d", doubleSolidEndPath);
                this.startArrow.setAttribute("fill", this.borderColor);
                this.endArrow.setAttribute("fill", this.borderColor);
                this.startArrow.setAttribute('stroke-width', this.borderWidth > 1 ? this.borderWidth - this.borderWidth / 4 : this.borderWidth);
                this.endArrow.setAttribute('stroke-width', this.borderWidth > 1 ? this.borderWidth - this.borderWidth / 4 : this.borderWidth);
                break;
            default:
                this.lineDom.setAttribute('stroke-linecap', 'round');
                break;
        }
        this.endArrow.setAttribute('stroke-linecap', 'round');
        this.startArrow.setAttribute('stroke-linecap', 'round');
    }
    // 设置填充颜色
    setFillColor() {
        this.lineGDom.style.stroke = this.borderColor;
    }    
    // 设置边框颜色
    setBorderColor() {}
    // 显示隐藏
    isShow(value) {
        this.fcHide = value;
        value ? this.lineGDom.style.display = 'block' : this.lineGDom.style.display = 'none';
    }
    init() {
        super.init();
        //箭头缩放
        this.arrowWidth = this.initArrowWidth * this.magnification.x;
        //根据边框对画布宽高调整
        // 根据x y 因边框、缩放改变导致绘制线重新计算
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = parseFloat(points0 * this.magnification.x) - this.borderWidth / 2+ this.cx - this.parent.parentX;
            this.points[i][1] = parseFloat(points1 * this.magnification.y) - this.borderWidth / 2+this.cy - this.parent.parentY;
        }
    }

    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.lineGDom);
        this.lineGDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.lineGDom.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }

    /**
     * 计算箭头坐标箭头
     * @param startX
     * @param startY
     * @param endX
     * @param endY
     * @param par
     * @param isSolid
     * @returns path
     */
    calculateArrowCoordinates_right(startX, startY, endX, endY, Par) {
        let slopy = Math.atan2((startY - endY), (startX - endX));
        let cosy = Math.cos(slopy);
        let siny = Math.sin(slopy);
        let x1 = Number(endX) + Number(Par * cosy - (Par / 1.3 * siny));
        let y1 = Number(endY) + Number(Par * siny + (Par / 1.3 * cosy));
        let x2 = Number(endX) + Number(Par * cosy + Par / 1.3 * siny);
        let y2 = Number(endY) - Number(Par / 1.3 * cosy - Par * siny);

        return `M ${x1} ${y1} L ${endX} ${endY} L ${x2} ${y2}`;
    }
    calculateArrowCoordinates_left(startX, startY, endX, endY, Par) {
        let slopy = Math.atan2((endY - startY), (endX - startX));
        let cosy = Math.cos(slopy);
        let siny = Math.sin(slopy);
        let x1 = Number(startX) + Number(Par * cosy - (Par / 1.3 * siny));
        let y1 = Number(startY) + Number(Par * siny + (Par / 1.3 * cosy));
        let x2 = Number(startX) + Number(Par * cosy + Par / 1.3 * siny);
        let y2 = Number(startY) - Number(Par / 1.3 * cosy - Par * siny);

        return `M ${x1} ${y1} L ${startX} ${startY} L ${x2} ${y2}`;
    }
    //生成path路径
    getLinePath(x1, y1, x2, y2) {
        //非数值单位计算，如当宽度像100%则移除
        if (isNaN(x1 - y1 + x2 - y2)) return;
        x1 = x1 || 0; 
        y1 = y1 || 0; 
        x2 = x2 || 0; 
        y2 = y2 || 0; 
        var path = 'M' + x1 + ' '+ y1 + 'L' + x2 + ' ' + y2;
        return path;
    }

}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvLineObj.js